













import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
@Component
export default class VariableDisplayText extends Vue {
  @Prop() private value?: string;
  @Prop() private options?: [];
}
